"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WorkbookImpl = /** @class */ (function () {
    function WorkbookImpl() {
    }
    return WorkbookImpl;
}());
exports.WorkbookImpl = WorkbookImpl;
//# sourceMappingURL=WorkbookImpl.js.map